<template>
  <div class="doubles-sub-tab">
    <Alert v-if="!tableData.length" :text="alertText" />
    <SubpanelTable
      v-else
      module="HRPAC_CANDIDATES_DUPLICATES"
      :tableColumns="tableColumns"
      :tableData="tableData"
      :showActionColumn="isFoundDuplicatesTable"
      :height="tableHeight"
    />
  </div>
</template>

<script>
import { store } from '@/store';
import Alert from 'Elements/Alert/Alert';
import SubpanelTable from 'Elements/Table/SubpanelTable';
export default {
  components: { Alert, SubpanelTable },
  data() {
    return {
      tableColumns: {
        last_name: {
          lbl: {
            value: 'Фамилия'
          }
        },
        first_name: {
          lbl: {
            value: 'Имя'
          }
        },
        middle_name: {
          lbl: {
            value: 'Отчество'
          }
        },
        date_entered: {
          lbl: {
            value: 'Дата'
          }
        }
      }
    };
  },
  computed: {
    tableHeight() {
      const count =
        store.state.subpanels.activeSubpanelData[this.subpanelId].data.List
          ?.length || 0;
      return count ? (count * 50 + 50).toString() : '0';
    },
    tableData() {
      return (
        store.state.subpanels.activeSubpanelData[this.subpanelId].data.List ||
        []
      );
    },
    isFoundDuplicatesTable() {
      return this.subpanelId == 'found_duplicates';
    },
    subpanelId() {
      return (
        store.state.subpanels.activeSubpanel?.doubles?.id || 'found_duplicates'
      );
    },
    alertText() {
      return this.subpanelId == 'found_duplicates'
        ? 'Дублей не найдено'
        : 'Кандидатов не найдено';
    }
  }
};
</script>

<style lang="scss" scoped>
.doubles-sub-tab {
  padding: 16px 24px;
}
</style>
